/*
 * 开关（接触器）— 矢量示意
 */
import Konva from 'konva'
import { GraphElement } from '../graph-element.js'
import { createFromJSON } from './help.js'

class SwitchElement extends GraphElement {
  static fromJSON = createFromJSON(this)

  constructor(topology, x, y, attrs) {
    super(topology, 'switch', x, y, {
      text: '开关',
      port: true,
      ...attrs,
    })

    this.onLoad(() => {
      this.label.visible(false)
    })
  }

  addKeyShape(name, attrs) {
    const r = 14
    const cx = r + 4
    const cy = r + 6

    const g = new Konva.Group({
      x: 0,
      y: 0,
      isKeyShape: true,
      name: `${name}-img`,
    })

    g.add(
      new Konva.Circle({
        x: cx,
        y: cy,
        radius: r,
        fill: '#2F59EB',
        stroke: '#1a3d99',
        strokeWidth: 1,
      }),
    )
    g.add(
      new Konva.Line({
        points: [cx, cy - 8, cx, cy + 8],
        stroke: '#ffffff',
        strokeWidth: 3,
        lineCap: 'round',
      }),
    )

    this.keyShape = g
    this.g.add(g)
    setTimeout(() => this.executeLoadedHook(this.keyShape), 0)
  }

  get width() {
    return 36
  }

  get height() {
    return 40
  }
}

export { SwitchElement }
